var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Script Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.3,19a5.29,5.29,0,0,0,.07-.8,5.36,5.36,0,0,0,0-.8l1.76-1.31a.41.41,0,0,0,.1-.52l-1.57-2.86a.4.4,0,0,0-.49-.19l-2.05.78a6,6,0,0,0-1.37-.83l-.26-2.17a.43.43,0,0,0-.4-.36l-3.27-.06a.41.41,0,0,0-.41.33L31,12.37a6.26,6.26,0,0,0-1.39.77l-2-.86a.4.4,0,0,0-.5.17l-1.69,2.79a.41.41,0,0,0,.08.53l1.7,1.38a7,7,0,0,0-.08.8,7.16,7.16,0,0,0,.05.8l-1.76,1.31a.41.41,0,0,0-.1.52l1.57,2.87a.42.42,0,0,0,.5.18l2.05-.78a6.07,6.07,0,0,0,1.36.84l.26,2.17a.42.42,0,0,0,.4.35l3.26.06a.39.39,0,0,0,.41-.33l.36-2.16A6.49,6.49,0,0,0,36.87,23l2,.86a.41.41,0,0,0,.5-.17l1.69-2.79a.4.4,0,0,0-.09-.53Zm-6.11,1.93a2.86,2.86,0,1,1,2.92-2.8A2.85,2.85,0,0,1,33.19,20.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.84 52.5 15.66 52.5 15.66 6.5 50.84 6.5 50.84 43.12 40.84 52.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.44 52.5 40.44 43.03 50.84 43.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.41,
    y1: 31.3,
    x2: 32.87,
    y2: 31.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.41,
    y1: 40.32,
    x2: 32.87,
    y2: 40.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.41,
    y1: 35.58,
    x2: 38.8,
    y2: 35.58
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptSettings01);
export default __webpack_public_path__ + "static/media/Script_Settings_01.be47be16b1dc92985a4c1a9afc2a996b.svg";
export { ForwardRef as ReactComponent };